import moment from "moment";

function getDaysInMonth(year, monthIndex) {
  const daysInMonth = moment({ year, month: monthIndex }).daysInMonth();
  return Array.from({ length: daysInMonth }, (_, i) => i + 1);
}

const generateMonthField = (data) => {
  return data.map((item) => ({
    name: String(item),
    label: item,
    options: {
      sort: false,
    },
  }));
};

export const tableConfig = (year, month, title) => {
  const arr = getDaysInMonth(year, month - 1);
  return [
    {
      name: "name",
      label: title,
      options: {
        sort: false,
        setCellHeaderProps: () => ({
          style: { width: "100px", minWidth: "100px", textAlign: "center" },
        }),
      },
    },
    ...generateMonthField(arr),
    {
      name: "totalMonth",
      label: "Total",
      options: {
        sort: false,
      },
    },
    {
      name: "projection",
      label: "Proyeksi",
      options: {
        sort: false,
      },
    },
    {
      name: "productivity",
      label: "Productivity/day",
      options: {
        sort: false,
      },
    },
  ];
};

export const buildHeaders = (nameLabel, sampleRow) => {
  const { name, totalMonth, projection, productivity, ...days } =
    sampleRow || {};

  return [
    nameLabel,
    ...Object.keys(days),
    "Total",
    "Proyeksi",
    "Productivity/Day",
  ];
};

export const buildSheet = ({ title, nameLabel, data }) => ({
  name: title,
  headers: buildHeaders(nameLabel, data[0]),
  data: data.map(({ name, total, projection, productivity, ...rest }) => ({
    [nameLabel]: name,
    Total: total || 0,
    Proyeksi: projection || 0,
    "Productivity/Day": productivity || 0,
    ...rest,
  })),
});
